import { React, useEffect, useContext,useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import Main from "../pages/main";
import HomeRoutes from "./subRoute";
import Register from "../pages/register";
import PageNotFound from '../pages/pageNotFound';
import ForgotPassword from "../pages/forgotPassword";
import SharedCart from "../pages/sharedCart";
import RoomStatusPublic from "../pages/roomStatusPublic";
import { saveNewDocuments, getLastestDoc ,getHotels} from "../api/api";

/**
 * The AppRoutes component is the top level component for the application's client-side routing.
 * It uses the react-router-dom library to render different routes based on the user's login status.
 * If the user is not logged in, it renders a set of public routes (/, /register, /forgot-password).
 * If the user is logged in, it renders the HomeRoutes component.
 * The component also includes two useEffect hooks:
 * 1. The first hook checks if the user is not logged in and the current path is not one of the public routes.
 *    If so, it redirects the user to the root path.
 * 2. The second hook fetches the latest documents from the server when the component mounts.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com>
 */
export default function AppRoutes(props) {
  const user = useSelector((state) => state.user);
  const { sessionStatus } = props;
  const isLogging = user.isLoggedIn;
  const [hotels, setHotels] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const { data, isLoading, error } = useQuery({
    queryKey: ["hotels"],
    queryFn: getHotels,
    staleTime: Infinity, // This ensures the data is never considered stale and won't be refetched.
  });

  useEffect(() => {
    let url = location.pathname.split("/");
    let params = null;
    let base64String = "";

    if (url.length > 0) {
      base64String = url[url.length - 1];
    }

    if (
      !isLogging &&
      location.pathname !== "/register" &&
      location.pathname !== "/forgot-password" &&
      location.pathname !== "/roomstatus" &&
      location.pathname !== `/shared-cart/${base64String}`
    ) {
      navigate("/");
    }
  }, [isLogging, navigate, location.pathname]);

  useEffect(() => {
    const fetchDocs = async () => {
      // let docs= await getLastestDoc('en');
        //  let docs = await saveNewDocuments();
    };
    fetchDocs();
  });

  useEffect(() => {
    if (data) {
      setHotels(data);
    }
  }, [data]);

  return (
    <>
      {!isLogging ? (
        <Routes>
          <Route
            exact
            path="/"
            element={<Main session={sessionStatus} />}
          ></Route>
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/shared-cart/*" element={<SharedCart />} />
          <Route exact path="/roomstatus" element={<RoomStatusPublic hotels={hotels}/>}/>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      ) : (
        <HomeRoutes />
      )}
    </>
  );
}
